import React from 'react'
import { connect } from "react-redux";
import { subscriptionsActions, currencyActions, alertActions } from "_actions";
import PaymentForm from 'components/Payments/PaymentForm'

class CreateSubscription extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            subscriptionsData: {
                currency: '',
                amount: '',
                label: '',
            },
            submitting: false,
        };
    }

    componentDidMount() {
        const { dispatch } = this.props
        dispatch(currencyActions.getAll())
    }

    handleChange = (event) => {
        const { target: {name, value}} = event
        this.setState(prevState => ({
            subscriptionsData: {
                ...prevState.subscriptionsData,
                [name]: value
            }
        }))
    }

    handleSubmit = (event) => {
        event.preventDefault()
        const { subscriptionsData } = this.state
        const { dispatch } = this.props
        if (! subscriptionsData.currency || ! subscriptionsData.amount || !subscriptionsData.label) {
            dispatch(alertActions.error('All Form Fields are required'))
            return
        }
        if (isNaN(subscriptionsData.amount)) {
            dispatch(alertActions.error('Subscription Amount can only be numerical values'))
            return
        }
        this.setState({ submitting: true })
        dispatch(subscriptionsActions.createSubscription(subscriptionsData))
    }

    render() {
        const { currencies } = this.props
        const { subscriptionsData, submitting } = this.state
        
        return (
            <div className="main-content-wrapper top-rel-100 margin-0-40">
                <PaymentForm
                    title="Create Subscription"
                    formData={subscriptionsData}
                    currencies={currencies}
                    submitting={submitting}
                    url="/subscriptions"
                    actionType="Create"
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { currency: { all_currency } } = state;

    return {
        currencies: all_currency
    };
}

const createSubscriptionPage = connect(mapStateToProps)(CreateSubscription);
export { createSubscriptionPage as CreateSubscription};